export const LOAD_REPORTS = 'REPORTS/LOAD_REPORTS';
export const DELETE_REPORT = 'REPORTS/DELETE_REPORTS';
export const SET_LOADING_REPORTS = 'REPORTS/SET_LOADING_REPORTS';
export const STORE_REPORTS = 'REPORTS/STORE_REPORTS';
export const CREATE_REPORT = 'REPORTS/CREATE_REPORT';
export const EDIT_REPORT = 'REPORTS/EDIT_REPORT';
export const SET_REPORT_STORE = 'REPORTS/SET_REPORT_STORE';
export const LOAD_REPORTS_BY_DATE = 'REPORTS/LOAD_REPORTS_BY_DATE';
